// Per-URL debounced autosave. Best-effort PATCH with JSON body.
// Errors are swallowed (warn-logged) — autosave has no UI for failures.

const pending = new Map();

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || "";
}

async function performFetch(url, body) {
  try {
    const response = await fetch(url, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": csrfToken(),
      },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      console.warn(`autosaveDraft ${url} failed: ${response.status}`);
      return { ok: false, status: response.status };
    }
    return { ok: true, status: response.status };
  } catch (err) {
    console.warn(`autosaveDraft ${url} error:`, err);
    return { ok: false, error: err };
  }
}

function runFetch(url) {
  const entry = pending.get(url);
  if (!entry) return Promise.resolve();
  pending.delete(url);
  if (entry.timeoutId) clearTimeout(entry.timeoutId);

  const promise = performFetch(url, entry.latestBody);
  promise.then((result) => {
    entry.resolvers.forEach((resolve) => resolve(result));
  });
  return promise;
}

export function autosaveDraft({ url, body, debounceMs = 500 }) {
  const existing = pending.get(url);
  if (existing) {
    clearTimeout(existing.timeoutId);
    existing.latestBody = body;
    return new Promise((resolve) => {
      existing.resolvers.push(resolve);
      existing.timeoutId = setTimeout(() => runFetch(url), debounceMs);
    });
  }

  return new Promise((resolve) => {
    const entry = {
      latestBody: body,
      resolvers: [resolve],
      timeoutId: null,
    };
    entry.timeoutId = setTimeout(() => runFetch(url), debounceMs);
    pending.set(url, entry);
  });
}

export function flush(url) {
  if (!pending.has(url)) return Promise.resolve();
  return runFetch(url);
}

export function isPending(url) {
  return pending.has(url);
}

export function cancel(url) {
  const entry = pending.get(url);
  if (!entry) return;
  clearTimeout(entry.timeoutId);
  pending.delete(url);
  entry.resolvers.forEach((resolve) => resolve({ cancelled: true }));
}
